import React from 'react';
import { Icon } from './Icon.js';
export const IconAlignDistributeVerticalFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M16.25,16H1.75c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h14.5c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M16.25,3.5H1.75c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h14.5c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "3", y: "6.5", width: "12", height: "5", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconAlignDistributeVerticalFill18.js.map